const indexItems = [
  { title: '91视频专区', desc: '热门精选 · 每日更新', count: '2,350+', icon: 'ri-movie-line', color: 'bg-primary-100 text-primary-600' },
  { title: '97视频专区', desc: '最新上线 · 高清流畅', count: '1,890+', icon: 'ri-clapperboard-line', color: 'bg-accent-100 text-accent-700' },
  { title: '51视频网站', desc: '经典回顾 · 历年金榜', count: '3,120+', icon: 'ri-film-line', color: 'bg-secondary-200 text-secondary-700' },
  { title: '数字视频平台', desc: '独家频道 · 幕后花絮', count: '860+', icon: 'ri-tv-line', color: 'bg-primary-100 text-primary-600' },
  { title: '4K超清体验', desc: '视觉盛宴 · 纤毫毕现', count: '1,450+', icon: 'ri-4k-line', color: 'bg-accent-100 text-accent-700' },
  { title: '免费高清专区', desc: '0门槛 · 无需注册', count: '5,600+', icon: 'ri-vip-crown-line', color: 'bg-secondary-200 text-secondary-700' },
  { title: '社区精选', desc: '观众票选 · 口碑佳作', count: '980+', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-600' },
  { title: '创作者频道', desc: '原创扶持 · 新锐力量', count: '420+', icon: 'ri-user-star-line', color: 'bg-accent-100 text-accent-700' },
];

export function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            视频分类
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            宅男视频全站内容分类索引，快速找到你想看的内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="group p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer text-center"
            >
              <div className={`w-11 h-11 md:w-12 md:h-12 mx-auto rounded-lg ${item.color} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-medium text-primary-500">{item.count} 部资源</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const faqs = [
  {
    q: '宅男视频是否需要注册才能观看？',
    a: '宅男视频大部分免费高清内容无需注册即可直接在线观看。注册账号后可以享受收藏、历史记录、个性化推荐等更多便捷功能，但基础观看服务完全开放，真正做到0门槛畅享91视频、97视频等平台资源。',
  },
  {
    q: '91视频和97视频的内容更新频率如何？',
    a: '宅男视频与91视频、97视频等主流数字品牌保持紧密同步，热门内容通常在24小时内完成上线。平台设有专门的更新团队，确保51视频网站及数字视频平台的最新资源能够第一时间呈现在用户面前，每日都有新鲜内容可供选择。',
  },
  {
    q: '播放卡顿怎么办？有什么优化方法？',
    a: '宅男视频采用先进的CDN智能分发技术，默认适配您的网络环境提供最佳码率。如遇卡顿，可尝试切换清晰度档位、检查本地网络连接或清理浏览器缓存。移动端用户建议使用App客户端，内置的流畅播放引擎在网络不佳时也能保证观看体验。',
  },
  {
    q: '支持哪些设备观看？可以投屏吗？',
    a: '宅男视频全面支持电脑浏览器、手机浏览器、iOS及Android客户端等多终端观看。移动端App内置DLNA和AirPlay投屏功能，可一键将91在线视频等内容投射到电视大屏，享受家庭影院级的观影体验。',
  },
  {
    q: '平台内容是否安全合法？',
    a: '宅男视频作为正规运营的数字视频平台，严格遵守相关法律法规。平台聚合的91视频、97视频及51视频网站等内容均来自合法授权渠道，同时设有完善的内容审核机制，为用户提供安全、绿色的在线观看环境。',
  },
  {
    q: '如何投稿或推荐自己的视频内容？',
    a: '欢迎优质内容创作者与我们合作！您可以通过页面上方"联系我们"区域的投稿入口提交合作申请，或直接发送邮件至我们的商务合作邮箱。宅男视频设有创作者扶持计划，为有潜力的原创作者提供流量支持和资源倾斜。',
  },
];

export function SectionFAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            关于宅男视频使用的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.q}
              className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center mt-0.5">
                  <span className="text-xs font-bold text-primary-600">Q</span>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const topics = [
  { name: '91视频', heat: '极热', count: '12.8万', color: 'bg-primary-100 text-primary-700' },
  { name: '97视频', heat: '极热', count: '10.5万', color: 'bg-accent-100 text-accent-800' },
  { name: '免费高清', heat: '热门', count: '9.2万', color: 'bg-accent-100 text-accent-800' },
  { name: '在线观看', heat: '热门', count: '8.7万', color: 'bg-secondary-200 text-secondary-800' },
  { name: '51视频网站', heat: '热门', count: '7.3万', color: 'bg-secondary-200 text-secondary-800' },
  { name: '数字视频平台', heat: '上升', count: '6.9万', color: 'bg-primary-100 text-primary-700' },
  { name: '4K超清', heat: '上升', count: '5.8万', color: 'bg-secondary-200 text-secondary-800' },
  { name: '不卡顿', heat: '上升', count: '5.4万', color: 'bg-accent-100 text-accent-800' },
  { name: '91在线视频', heat: '热门', count: '5.1万', color: 'bg-primary-100 text-primary-700' },
  { name: '移动客户端', heat: '上升', count: '4.6万', color: 'bg-secondary-200 text-secondary-800' },
  { name: '视频投屏', heat: '新晋', count: '3.2万', color: 'bg-accent-100 text-accent-800' },
];

export function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            宅男视频平台当前最受关注的话题标签与热度排行
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className="group flex items-center gap-3 px-4 py-3 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${topic.color}`}>
                {topic.heat}
              </span>
              <span className="text-sm font-bold text-foreground-900 whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}